import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "row items-center" }

import { onUnmounted, ref } from 'vue';
import { cloneDeep } from 'lodash';
import AttachmentCollection from 'SharedComponents/Attachments/AttachmentCollection.vue';
import Uploader from 'SharedComponents/Attachments/Uploader.vue';
import ChatMessageInput from 'SharedDir/modules/Chats/ChatMessageInput.vue';
import { AttachmentsApi } from 'SharedDir/backend/api';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import ChatMessage from 'SharedDir/service/chats/classes/chat-message';

type InnerValueType = Pick<ChatMessage, 'message' | 'attachments'>;


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'SendChatMessage' },
  __name: 'SendChatMessage',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "send", "sent"],
  setup(__props: any, { emit: __emit }) {

const defaultMessage = () =>
  cloneDeep({
    message: '',
    attachments: [],
  });


const props = __props;
const emits = __emit;
const { innerValue, emitValue } = useValue<null | ChatMessage, InnerValueType>(props, emits, {
  transform: (v) => (v === null ? defaultMessage() : cloneDeep(v)),
});
const showDialog = ref(false);
const sending = ref(false);

function clearMessage() {
  innerValue.value = defaultMessage();
}

function removeFile(index) {
  innerValue.value.attachments.splice(index, 1);
}

function showInDialog() {
  showDialog.value = true;
}

function send() {
  sending.value = true;
  const result = new Promise((resolve, reject) => {
    emits('send', innerValue.value, resolve, reject);
  });
  result.then(done).finally(() => {
    sending.value = false;
  });
}

function done() {
  clearMessage();
  emits('sent');
}

function finish(event) {
  innerValue.value.attachments = event.files;
  console.debug(event);
}

function start(event) {
  console.debug('Started', event);
}

function singleFileUpload(files: FileList) {
  return AttachmentsApi.uploadFile(files);
}

onUnmounted(() => {
  showDialog.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_s_btn = _resolveComponent("s-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(innerValue).attachments.length > 0)
      ? (_openBlock(), _createBlock(AttachmentCollection, {
          key: 0,
          class: "attachment-list",
          list: _unref(innerValue).attachments
        }, {
          "attachment-control": _withCtx(({ index }) => [
            _createVNode(_component_q_icon, {
              class: "attachment-control",
              title: "Удалить",
              name: "las la-trash-alt",
              onClick: ($event: any) => (removeFile(index))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["list"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Uploader, {
        uploader: singleFileUpload,
        onFinish: finish
      }, {
        default: _withCtx(({ trigger, uploading }) => [
          _createVNode(_component_s_btn, {
            ripple: false,
            disable: sending.value,
            class: _normalizeClass({ shaking: uploading }),
            flat: "",
            round: "",
            type: "icon",
            icon: "app:add-file",
            onClick: trigger
          }, null, 8, ["disable", "class", "onClick"])
        ]),
        _: 1
      }),
      _createVNode(ChatMessageInput, {
        modelValue: _unref(innerValue).message,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(innerValue).message) = $event)),
        sending: sending.value,
        class: "col",
        onSend: send
      }, null, 8, ["modelValue", "sending"])
    ])
  ]))
}
}

})